import React, { useEffect, useState } from 'react';
import { Alert, TextField, Button, Grid2, MenuItem, Select, FormControl, InputLabel, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { reportServices } from '../../services/reportServices';
import Clear from '@mui/icons-material/Clear';
import GetApp from '@mui/icons-material/GetApp';
import { downloadReport } from '../../utils/downloadReport ';
import '../../css/Reports.css';
import ReportGenerateButton from '../common/ReportGenerateButton';
import PageHeader from '../ui/PageHeader';

const EmpExtraTaskReport = ({ showHeader = true }) => {

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [selectedTaskTitle, setSelectedTaskTitle] = useState('');
    const [taskTitleData] = useState([
        { value: 1, label: "Office Meeting" },
        { value: 2, label: "Free" },
        { value: 3, label: "Attending Training" },
        { value: 4, label: "Providing Training" },
        { value: 5, label: "Break" },
        { value: 6, label: "Fun Activity/Celebration" },
        { value: 7, label: "Email/Workflow" },
        { value: 8, label: "Filling of VAT/A/c/Tax" },
        { value: 9, label: "Guiding to Team Member" },
        { value: 10, label: "10 Minutes Reading" },
        { value: 11, label: "QC Review" },
        { value: 12, label: "Marketing" },
        { value: 13, label: "Task Assignment" },
        { value: 14, label: "IT" },
    ]);
    const { t, i18n } = useTranslation();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState('');
    const [generating, setGenerating] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);


    const handleClear = () => {
        setStartDate('');
        setEndDate('');
        setSelectedTaskTitle('');
    };

    const handleReport = () => {
        setGenerating(true);
        const formData = {
            startDate,
            endDate,
            taskTitle: selectedTaskTitle
        };
        if (startDate <= endDate) {
            reportServices.downloadEmployeeExtraTaskReport(formData)
                .then((response) => {

                    downloadReport(response);

                    setGenerating(false);
                    setSuccessMessage("Report Generated Successfully!");
                    setTimeout(() => setSuccessMessage(null), 4000);

                    setStartDate('');
                    setEndDate('');
                    setSelectedTaskTitle('');
                })
                .catch((error) => {
                    setError(error.message);
                    setTimeout(() => {
                        setError(null);
                    }, 4000);
                });
        } else {
            setError('Error! Start date must be earlier than end date.');
            setTimeout(() => {
                setError(null);
            }, 4000);
        }

    };

    return (
        <div className={showHeader ? "reports-container" : ""}>
            {showHeader && (
                <PageHeader title="Employee Extra Tasks Report" />
            )}
            <Box className={showHeader ? "report-box" : ""}>

                {successMessage && (
                    <Alert variant="filled" severity="success" style={{ marginBottom: '1.25rem' }}>
                        {successMessage}
                    </Alert>
                )}

                {error && (
                    <Alert variant="outlined" severity="error" style={{ marginBottom: '1.25rem' }}>
                        {error}
                    </Alert>
                )}

                <form style={{ marginTop: '1.25rem' }}>
                    <Grid2 container spacing={3}>

                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="date"
                                label={t('report.startDate')}
                                variant="outlined"
                                fullWidth
                                required
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                margin="normal"
                                slotProps={{
                                    inputLabel: { shrink: true },
                                }}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <TextField
                                type="date"
                                label={t('report.endDate')}
                                variant="outlined"
                                fullWidth
                                required
                                disabled={startDate ? false : true}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                margin="normal"
                                slotProps={{
                                    inputLabel: { shrink: true },
                                }}
                            />
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <FormControl fullWidth margin="normal">
                                <InputLabel>Task Title</InputLabel>
                                <Select
                                    value={selectedTaskTitle}
                                    onChange={(e) => setSelectedTaskTitle(e.target.value)}
                                    label="Task Title"
                                    fullWidth
                                    required
                                >
                                    {taskTitleData.map((task) => (
                                        <MenuItem key={task.value} value={task.label}>
                                            {task.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid2>

                        <Grid2 size={{ xs: 12 }} className="gridContainer">
                            <ReportGenerateButton
                                onClick={handleReport}
                                loading={generating}
                                disabled={!(startDate && endDate && selectedTaskTitle) || (Boolean(loading) || generating)}
                                className={`commonButton ${(startDate && endDate && selectedTaskTitle) ? 'reportButtonSuccess' : 'reportButtonDefault'}`}
                                icon={<GetApp />}
                                label={t('job.report')}
                                loadingLabel="Preparing your report..."
                            />
                            <Button
                                type="button"
                                variant="contained"
                                onClick={handleClear}
                                className={`commonButton clearButton`}
                                disabled={(Boolean(loading) || generating)}
                            >
                                <Clear style={{ marginRight: '0.5rem' }} /> {t('job.clear')}
                            </Button>
                        </Grid2>

                    </Grid2>
                </form>
            </Box>
        </div>
    );
};

export default EmpExtraTaskReport;
